import React from 'react';
import { FunctionFactory } from 'survey-core';
import { Gender } from '../quiz/gender';
import { getTestimonialByName } from './testimonials';
import { getGenderKey } from '../features/utils';
import { Physiology } from '../quiz/physiology';

const muscleFocusSplashHtml = `
<div class="new-quote-container">
  <div class="quote-img-container" style="margin-top: 16px">
    <img src="{muscleFocusImgUrl}" alt="Testimonial from a user like you!" />
  </div>
  <div class="image-footnote">{muscleFocusQuoterName} – Real Built With Science Member</div>
  <div class="quote">
    {muscleFocusQuote}
  </div>
</div>`;

const muscleFocusQuoteExpression = {
  name: "muscleFocusQuote",
  expression: "renderMuscleFocusQuote({gender}, {physiology})",
};

const muscleFocusImgUrlExpression = {
  name: "muscleFocusImgUrl",
  expression: "renderMuscleFocusImgUrl({gender}, {physiology})",
}

const muscleFocusQuoterNameExpression = {
  name: "muscleFocusQuoterName",
  expression: "renderMuscleFocusQuoterName({gender}, {physiology})",
}

function renderMuscleFocusQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Male: {
      return getTestimonialByName('Patrick R.').testimonial;
    }
    case Gender.Female: {
      return getTestimonialByName('Tahnee S.').testimonial;
    }
  }
}

function renderMuscleFocusQuoterName(params: any[]): string {
  if (params === undefined || params === null) return "";
  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Male: {
      return `Patrick R.`;
    }
    case Gender.Female: {
      return `Tahnee S.`;
    }
  }
}


function renderMuscleFocusImgUrl(params: any[]): string {
  if (params === undefined || params === null) return "";
  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Male: {
      return getTestimonialByName('Patrick R.').image;
    }
    case Gender.Female: {
      return getTestimonialByName('Tahnee S.').image;
    }
  }
}

FunctionFactory.Instance.register("renderMuscleFocusQuote", renderMuscleFocusQuote);
FunctionFactory.Instance.register("renderMuscleFocusImgUrl", renderMuscleFocusImgUrl);
FunctionFactory.Instance.register("renderMuscleFocusQuoterName", renderMuscleFocusQuoterName);

const MuscleFocusSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      📸 Framing expectations
    </div>
  )
}

const muscleFocusSplashElement = {
  name: 'muscle-focus-splash',
  type: 'html',
  html: muscleFocusSplashHtml,
};

export {
  muscleFocusSplashElement,
  muscleFocusQuoteExpression,
  muscleFocusImgUrlExpression,
  muscleFocusQuoterNameExpression,
  MuscleFocusSplashHeader,
}
